export const globals = {
  activeUpsells(state, getters, rootState, rootGetters) {
    if (!state.globals.upsells) return [];
    return state.globals.upsells.reduce((_activeUpsells, upsell) => {
      const productVariants =
        getters.getVariantsFromProductUpsells(
          upsell,
          rootGetters["cart/optionsScoreMap"]
        ) || [];
      if (!availableUpsell(upsell, productVariants)) {
        return _activeUpsells;
      }

      const validUpsell = validateUpsell(upsell, _activeUpsells, rootState);
      return validUpsell ? [..._activeUpsells, upsell] : _activeUpsells;
    }, []);
  },
  upsells(_state, getters) {
    const _upsells = getters.activeUpsells.filter(
      (upsell) => !upsell.gift_with_purchase
    );
    return _upsells.sort((a, b) => {
      if (!a.index && !b.index) return 0;
      if (!a.index) return 1;
      if (!b.index) return -1;
      return parseFloat(a.index) - parseFloat(b.index);
    });
  },
  getVariantsFromProductUpsells: () => (upsell, optionsScoreMap) => {
    // Map variants to each products in an upsell based on the carts score map
    if (!upsell.products.length) return null;
    const products = upsell.products;
    // Select the variant that matches the highest weighted option for each product or the first available variant
    const selectedVariants = products.map((product) => {
      const selectedOption = optionsScoreMap.find(({ name }) => {
        return product.variants.find((variant) => {
          const mappedVariants = variant.options.map(
            (option) => variantOptionMap[option] || option
          );
          return mappedVariants.includes(name);
        });
      });

      return selectedOption
        ? product.variants.find((variant) => {
            const mappedVariants = variant.options.map(
              (option) => variantOptionMap[option] || option
            );
            return mappedVariants.includes(selectedOption.name);
          })
        : product.variants.find((variant) => variant.available);
    });
    // Get variants of the the upsells' products based on the cart's optionScoreMap
    return selectedVariants.filter((_variant) => _variant);
  },
  getUpsellPrices: (_state, getters, _rootState, rootGetters) => (upsell) => {
    let price;
    let compareAtPrice;

    if (upsell.price || upsell.price === 0) {
      price = upsell.price;
    } else if (upsell.variants.length && upsell.variants[0].variant.price) {
      price = upsell.variants[0].variant.price;
    } else if (upsell.products.length) {
      const productVariants =
        getters.getVariantsFromProductUpsells(
          upsell,
          rootGetters["cart/optionsScoreMap"]
        ) || [];
      productVariants.length
        ? (price = productVariants[0].price)
        : (price = null);
    } else {
      price = null;
    }

    if (upsell.compare_at_price || upsell.compare_at_price === 0) {
      compareAtPrice = upsell.compare_at_price;
    } else if (
      upsell.variants.length &&
      upsell.variants[0].variant.compare_at_price
    ) {
      compareAtPrice = upsell.variants[0].variant.compare_at_price;
    } else if (upsell.products.length) {
      const productVariants =
        getters.getVariantsFromProductUpsells(
          upsell,
          rootGetters["cart/optionsScoreMap"]
        ) || [];
      productVariants.length
        ? (compareAtPrice = productVariants[0].compare_at_price)
        : (compareAtPrice = null);
    } else {
      compareAtPrice = null;
    }

    return { price, compareAtPrice };
  },
  getCustomerLoyaltyTier: (state) => () => {
    return state.globals.customer_loyalty_tier;
  },
};

export const validateUpsell = (upsell, activeUpsells, rootState) => {
  const cart = rootState.cart.data;
  if (upsell.allow_multiple) {
    if (isUpsellLimitExceeded(upsell, cart.items)) {
      return false;
    }
  } else {
    if (isUpsellInCart(upsell, cart.items)) {
      return false;
    }
  }
  if (existsInUpsells(upsell, activeUpsells)) {
    return false;
  }
  if (!validUpsell(upsell, cart)) {
    return false;
  }
  return true;
};

// Map unique variant options to more common variant options on upsells
export const variantOptionMap = {
  Sunset: "Spice",
  Twilight: "Blue Salt",
  Dusk: "Steam",
  Clear: "Char",
  Dawn: "Sage",
  Sunrise: "Heat",
  Chickpea: "Steam",
  Turmeric: "Spice",
  Saffron: "Spice",
  Coriander: "Saffron",
};

export const validUpsell = (upsell, cart) => {
  if (!upsell.products.length && !upsell.variants.length) return false;
  if (upsell.minimum_line_items && upsell.minimum_line_items > cart.item_count)
    return false;
  if (upsell.minimum_price && upsell.minimum_price > cart.total_price)
    return false;

  const cartProductIds = cart.items.map((item) => item.product_id);
  const cartVariantIds = cart.items.map((item) => item.id);

  if (upsell.or) {
    const hasRequiredProduct = upsell.required_product_ids.find((productId) =>
      cartProductIds.includes(productId)
    );
    const hasRequiredVariant = upsell.required_variant_ids.find((variantId) =>
      cartVariantIds.includes(variantId)
    );
    if (!hasRequiredProduct && !hasRequiredVariant) return false;
  } else {
    const hasAllRequiredProducts = upsell.required_product_ids.every(
      (productId) => cartProductIds.includes(productId)
    );
    const hasAllRequiredVariants = upsell.required_variant_ids.every(
      (variantId) => cartVariantIds.includes(variantId)
    );
    if (!hasAllRequiredProducts || !hasAllRequiredVariants) return false;
  }

  window.showUpsells = window.showUpsells || [];
  if (upsell.hide && !window.showUpsells.includes(upsell.key)) {
    return false;
  }

  return true;
};

export const isUpsellInCart = (upsell, cartItems) => {
  const upsellsInCart = cartItems.filter(
    ({ product_id: productId, quantity }) => {
      const matchingProduct = upsell.products.find(
        ({ id }) => String(id) === String(productId)
      );
      const matchingVariant = upsell.variants.find(
        (variant) => String(variant.product_id) === String(productId)
      );

      return matchingProduct || matchingVariant;
    }
  );
  return upsellsInCart.length;
};

export const isUpsellLimitExceeded = (upsell, cartItems) => {
  if (!upsell.allow_multiple) return false;
  const requiredProductIds = upsell.products
    .map((product) => product.id)
    .concat(upsell.variants.map((upsellVariant) => upsellVariant.product_id));

  const matchesLimit = requiredProductIds.filter((productId) => {
    const matchingLineItem = cartItems.find(
      (lineItem) => String(lineItem.product_id) === String(productId)
    );
    if (!matchingLineItem) return false;
    return matchingLineItem.quantity >= upsell.allow_multiple;
  });

  return matchesLimit.length >= requiredProductIds.length;
};

// Checks if an upsells products + variants match with an already existing active upsell
export const existsInUpsells = (upsell, activeUpsells) => {
  return activeUpsells.find(({ products, variants }) => {
    if (!products.length && !variants.length) {
      return true;
    }
    const productIds = products.map((product) => product.id);
    const variantIds = variants.map(({ variant }) => variant.id);

    const matchesAllProducts = productIds.every((productId) => {
      const currentUpsellProductIds = upsell.products.map(
        (product) => product.id
      );
      return currentUpsellProductIds.includes(productId);
    });

    const matchesAllVariants = variantIds.every((variantId) => {
      const currentUpsellVariantIds = upsell.variants.map(
        ({ variant }) => variant.id
      );
      return currentUpsellVariantIds.includes(variantId);
    });

    return matchesAllProducts && matchesAllVariants;
  });
};

export const availableUpsell = (upsell, productVariants) => {
  const variants =
    upsell.variants
      .map((variantUpsell) => variantUpsell.variant)
      .filter((_v) => _v) || [];
  const upsellVariants = productVariants.concat(variants);
  const unavailableVariant = upsellVariants.find(
    (variant) => variant && !variant.available
  );
  return !unavailableVariant;
};

// Checks if any variants in an upsell exceeds its quantity limit specified in ACF (variant.metafields.accentuate.item_quantity_limit)
export const upsellExceedsQuantityLimit = (
  upsell,
  cartItems,
  variantsMetafields,
  productVariants
) => {
  const variants =
    upsell.variants.map((variantUpsell) => variantUpsell.variant) || [];
  const upsellVariants = productVariants.concat(variants);
  return upsellVariants.find((variant) => {
    if (!variantsMetafields) return false;
    const variantMetafields = variantsMetafields.find(
      (currentVariantMetafields) =>
        String(currentVariantMetafields.id) === String(variant.id)
    );
    if (!variantMetafields) return false;
    const quantityLimit = variantMetafields.item_quantity_limit;
    if (quantityLimit) {
      const variantQuantityInCart = cartItems.reduce(
        (trueQuantity, cartItem) => {
          if (String(cartItem.id) === String(variant.id))
            return trueQuantity + cartItem.quantity;
          return trueQuantity;
        },
        0
      );
      if (quantityLimit && quantityLimit <= variantQuantityInCart) return true;
    }

    return false;
  });
};

// Checks if any variants in an upsell exceeds its quantity limit based on its '_reactive' property
export const upsellExceedsGwpLimit = (upsell, cartItems) => {
  const variantProductIds =
    upsell.variants.map((variantUpsell) => variantUpsell.product_id) || [];
  const upsellProductIds = upsell.products.concat(variantProductIds);
  // get quantity of items of all matching products of the current upsell variants
  const upsellsQuantity = upsellProductIds.reduce(
    (totalQuantity, productId) => {
      const productQuantity = cartItems.reduce((_productQuantity, item) => {
        if (String(item.product_id) === String(productId))
          return _productQuantity + item.quantity;
        return _productQuantity;
      }, 0);

      return parseInt(totalQuantity) + parseInt(productQuantity);
    },
    0
  );

  // get quantity of items of all required variants of the current upsell
  const requiredProductItems = cartItems
    .filter((item) => {
      return upsell.required_product_ids.includes(item.product_id);
    })
    .map((requiredProductItem) => requiredProductItem.id);
  const reactiveItems = [
    ...requiredProductItems,
    ...upsell.required_variant_ids,
  ];
  const itemsToReact = cartItems.filter((_item) => {
    return reactiveItems.includes(_item.id);
  });
  const itemsToReactQuantity = itemsToReact.reduce(
    (totalQuantity, _item) => totalQuantity + _item.quantity,
    0
  );
  if (upsellsQuantity >= itemsToReactQuantity) return true;
  return false;
};
